<template>
  <span ref="dropdown" class="dropdown">
    <app-button :data-qa="(id ? `${id}-` : '') + 'dropdown-button'" @click.stop="toggleDropdown">
      {{ buttonText }}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-caret-down-fill"
        viewBox="0 0 16 16"
      >
        <path
          d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
        />
      </svg>
    </app-button>
    <ul v-if="isOpen" class="dropdown-menu">
      <slot />
    </ul>
  </span>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'

export default {
  components: { AppButton },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    toggleDropdown() {
      if (this.isOpen) this.closeDropdown()
      else this.openDropdown()
    },
    openDropdown() {
      this.isOpen = true
      this.$nextTick(() => {
        this.addEventListeners()
      })
    },
    closeDropdown() {
      this.isOpen = false
      this.removeEventListeners()
    },
    closeByClickingOutsideDropdown(event) {
      this.closeDropdown()
    },
    addEventListeners() {
      document.addEventListener('keydown', this.closeByEscapeKey)
      document.addEventListener('click', this.closeByClickingOutsideDropdown)
    },
    removeEventListeners() {
      document.removeEventListener('keydown', this.closeByEscapeKey)
      document.removeEventListener('click', this.closeByClickingOutsideDropdown)
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  inset: 0px auto auto 0px;
  transform: translate(0px, 40px);

  z-index: 1000;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

:deep(.dropdown-item) {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;

  &:hover {
    color: #1e2125;
    background-color: #e9ecef;
  }
}
</style>
